export interface Service {
  header?: string;
  headerIcon?: string;
  description?: string;
  typicalTotalPrice?: number;
  src?: string;
  type: ServiceType;
  link: string;
  videoSrc?: string;
}

export enum ServiceType {
  ACTION_PLAN = 'ActionPlan',
  APPOINTMENT_SETTER = 'AppointmentSetter',
  LEAD_GENERATOR = 'LeadGenerator',
  SUPPORT_AGENT = 'SupportAgent',
  CALL_CENTER = 'CallCenter',
}

export enum ServiceUrl {
  ACTION_PLAN = 'ai-action-plan',
  APPOINTMENT_SETTER = 'ai-appointment-setter',
  LEAD_GENERATOR = 'ai-lead-generator',
  SUPPORT_AGENT = 'ai-support-agent',
  CALL_CENTER = 'ai-call-center',
}

// These services uses these SEO URLs in all environments
export enum AI_SERVICES_SEO_URL {
  ACTION_PLAN = 'artificial_intelligence/ai-action-plan',
  LEAD_GENERATOR = 'artificial_intelligence/ai-lead-generator',
  APPOINTMENT_SETTER = 'artificial_intelligence/ai-appointment-setter',
  SUPPORT_AGENT = 'artificial_intelligence/ai-support-agent',
  CALL_CENTER = 'artificial_intelligence/ai-call-center',
}

export interface ServiceInfo {
  serviceUrl: ServiceUrl;
  seoUrl: AI_SERVICES_SEO_URL;
  type: ServiceType;
  retellAiAgentId: string;
}

export const aiServicesInfo: readonly ServiceInfo[] = [
  {
    serviceUrl: ServiceUrl.ACTION_PLAN,
    seoUrl: AI_SERVICES_SEO_URL.ACTION_PLAN,
    type: ServiceType.ACTION_PLAN,
    retellAiAgentId: 'agent_eb99fa62ee812469540fd20cc0',
  },
  {
    serviceUrl: ServiceUrl.LEAD_GENERATOR,
    seoUrl: AI_SERVICES_SEO_URL.LEAD_GENERATOR,
    type: ServiceType.LEAD_GENERATOR,
    retellAiAgentId: 'agent_0eb9f0abcbaaa5a11f4a8bcd45',
  },
  {
    serviceUrl: ServiceUrl.APPOINTMENT_SETTER,
    seoUrl: AI_SERVICES_SEO_URL.APPOINTMENT_SETTER,
    type: ServiceType.APPOINTMENT_SETTER,
    retellAiAgentId: 'agent_430161143862f945f9e87518e1',
  },
  {
    serviceUrl: ServiceUrl.SUPPORT_AGENT,
    seoUrl: AI_SERVICES_SEO_URL.SUPPORT_AGENT,
    type: ServiceType.SUPPORT_AGENT,
    retellAiAgentId: 'agent_ad343252bdd0ca3388ea7ccb1f',
  },
  {
    serviceUrl: ServiceUrl.CALL_CENTER,
    seoUrl: AI_SERVICES_SEO_URL.CALL_CENTER,
    type: ServiceType.CALL_CENTER,
    retellAiAgentId: 'agent_7eebab2c22c34d88d4ec57b22f',
  },
];

export interface ModalStateChangeEvent {
  serviceType: ServiceType;
  open: boolean;
}
